import {renderCountDown} from './ContestOverview';
import "../../../src/VX/Asset/Less/VX/View/ContestsDetails.less";

function run(activeContest) {
	renderCountDown(activeContest);
}

export {run};
